export const Schema = () => {
  return {
    category: 'Product',
    label: 'Related Products',
    key: 'related-products',
    previewSrc:
      'https://cdn.shopify.com/s/files/1/1011/0318/files/featured-products.png?v=1685571408',
    fields: [
      {
        name: 'sectionTitle',
        component: 'text',
        label: 'Section Title',
        defaultValue: 'Related Products',
      },
      {
        name: 'sectionLink',
        component: 'link',
        label: 'Section Link',
      },
      {
        name: 'relatedProducts',
        component: 'group-list',
        label: 'Related Products',
        itemProps: {
          label: '{{item.featuredProduct.title}}',
        },
        validate: {
          maxItems: 4,
        },
        fields: [
          {
            label: 'Related Product',
            component: 'productSearch',
            name: 'featuredProduct',
          },
        ],
      },
    ],
  };
};
